/*
 *  DESIGN:
 *     - It may be an idea npt to store data data in cookie as it porentialy poses security risk.
 *       Alaternative woudl be to store state data in session storage, as this is cleared when
 *       the browser is closed. However the cookie method means that user has the option of not
 *       having to log back in.
 *
 *     https://stackoverflow.com/questions/43027499/vuex-state-on-page-refresh
 * */

/*
 *   V 0.5.0 - 2025-09-09
 *      - Button settings for Trip Navigator
 *
 *   V 0.4.0 - 2025-03-17
 *      - Added SimpleView for users that only have a Moles in their
 *        fleet
 *   V 0.3.0 - 2024-10-23
 *      - Added controlView so that control room could have different view
 *        to what normal users see
 *
 *   V 0.2.1 - 2023-02-20
 *      - MOved to Mobile App from Template App
 *
 *   V 0.2 - 2022-03-15
 *      -  Added  timerValue
 *
 *   V 0.1 - 2022-03-07
 *       - added  JSON.parse  and JSON.stringify so that the write to the
 *         cookie is correctly serialsed and de-serialised.
 *
 *     0.1.1  remove import * as jsCookies from 'js-cookie'
 *
 * */

import Vue from 'vue'
/*

  vuex version must be < 4.0, as there are changes that break

*/
import Vuex from 'vuex'
// import jsCookies from 'npm';
import * as jsCookies from 'js-cookie'
import CreatePersistedState from 'vuex-persistedstate'
// import { get } from 'core-js/core/dict' // 2026-02-16 <- line was causing problems

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: 'TEST_VAL',
    isLoggedIn: false,
    userName: '',
    roles: '',
    tenantCode: '',
    test: false,
    timerValue: 25000,
    debug: false,
    controlView: false,
    simpleView: false,

    // Button settings for Trip Navigator
    allTripsButton: false,
    eventsButton: true,
    zoomButton: false,
    navPlayTimerInterval: 3000,
    tripButtons: []
  },

  mutations: {
    setTenantCode (state, value) {
      state.tenantCode = value
    },

    setRoles (state, value) {
      state.roles = value
    },

    setToken (state, value) {
      state.token = value
    },

    setIsLoggedIn (state, value) {
      state.isLoggedIn = value
    },

    setUserName (state, value) {
      state.userName = value
    },

    setTest (state, value) {
      state.test = value
    },

    setTimerValue (state, value) {
      state.timerValue = value
    },

    setDebug (state, value) {
      state.debug = value
    },

    setControlView (state, value) {
      state.controlView = value
    },

    setSimpleView (state, value) {
      state.simpleView = value
    },

    setAllTripsButton (state, value) {
      state.allTripsButton = value
    },

    setEventsButton (state, value) {
      state.eventsButton = value
    },

    setNavPlayTimerInterval (state, value) {
      state.navPlayTimerInterval = value
    },

    setTripButtons (state, value) {
      state.tripButtons = value
    }

  },

  getters: {
    getTenantCode: (state) => state.tenantCode,

    getRoles: (state) => state.Roles,

    getToken: (state) => state.token,

    getIsLoggedIn: (state) => state.isLoggedIn,

    getUserName: (state) => state.userName,

    getTimerValue: (state) => state.timerValue,

    getDebug: (state) => state.debug,

    getControlView: (state) => state.controlView,

    getSimpleView: (state) => state.simpleView,

    getAllTripsButton: (state) => state.allTripsButton,

    getEventsButton: (state) => state.eventsButton,

    getNavPlayTimerInterval: (state) => state.navPlayTimerInterval,

    getTripButtons: (state) => state.tripButtons

  },

  /// -------------------------------------------------------------------------
  //    Uncomment below for localstorage.
  /// -------------------------------------------------------------------------

  /// plugins: [CreatePersistedState()]

  /// -------------------------------------------------------------------------
  ///    Comment out for CodeSandBox
  /// -------------------------------------------------------------------------

  plugins: [
    CreatePersistedState({
      getState: (key) => {
        // debugger;
        const json = jsCookies.get(key)
        if (typeof json === 'undefined') {
          return null
        }
        return JSON.parse(json)
      },
      setState: (key, state) => {
        const obj = JSON.stringify(state)
        jsCookies.set(key, obj, { expires: 3, secure: true })
      }
    })
  ]

  /// -------------------------------------------------------------------------
  /// -------------------------------------------------------------------------
})
